module.exports = __webpack_public_path__ + "static/media/tpn-mockup-3.d480a7b6.jpg";